import {
  Datagrid,
  TextField,
  NumberField,
  Loading,
  FunctionField,
  ListContextProvider,
  useList,
  useRecordContext,
} from 'react-admin';
import { Box } from '@mui/material';
import { AddMachineToGroupButton } from './AddMachineToGroupButton';
import { RemoveMachineFromGroupButton } from './RemoveMachineFromGroupButton';
import { useFetchRecordAssociation, EmptyList } from '../../utils';
import { Machine, Group } from '../../types';

export const GroupMachinesList = () => {
  const groupRecord = useRecordContext<Group>();
  const {
    data: machines,
    loading,
    refresh,
  } = useFetchRecordAssociation<Machine>({
    getEndpoint: (id) => `/api/groups/${id}/machines`,
  });

  const listContext = useList({
    data: machines,
    sort: { field: 'id', order: 'ASC' },
  });

  if (loading) return <Loading />;

  if (!machines || machines.length === 0) {
    return (
      <EmptyList
        message="This group has no machines associated."
        action={<AddMachineToGroupButton onSuccess={refresh} />}
      />
    );
  }

  return (
    <>
      <ListContextProvider value={listContext}>
        <Datagrid
          bulkActionButtons={false}
          rowClick={(id) => `/machines/${id}/show`}
          sx={{
            '& .column-id': { textAlign: 'left' },
            '& .column-id th': { textAlign: 'left' },
          }}
        >
          <NumberField source="id" textAlign="left" sortable />
          <TextField source="serial" sortable />
          <FunctionField
            onClick={(e) => e.stopPropagation()}
            render={(machine: Machine) => (
              <RemoveMachineFromGroupButton
                groupId={groupRecord?.id || 0}
                groupName={groupRecord?.name || ''}
                machineId={machine.id}
                machineSerial={machine.serial}
                onSuccess={refresh}
              />
            )}
          />
        </Datagrid>
      </ListContextProvider>
      <Box sx={{ mt: 1, mb: 1, textAlign: 'right' }}>
        <AddMachineToGroupButton onSuccess={refresh} />
      </Box>
    </>
  );
};
